import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=89fe27ca&scoped=true&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=89fe27ca&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fe27ca",
  null
  
)

export default component.exports